import { Box, FormControl, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import { QUERY_PARAMS } from '../../constants'
import { CardBox, CardBoxTopBar, StyledInputLabel } from '../../theme/styleComponents'
import { anchorOrigin, transformOrigin } from '../../theme/styleConstants'
import { SearchWithKeypress } from '../common/SearchWithKeypress'
import { DateRanges } from '../entries/EntryFilters'
import UserFilter from '../entries/UserFilter'
import { ACTIVITY_TYPES } from './activityMeta'

const ActivityFilters = ({ setPage }: { setPage: React.Dispatch<React.SetStateAction<number>> }) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const getFilterValues = (key: QUERY_PARAMS) => searchParams.get(key) || QUERY_PARAMS.ALL

  const onChangeEntity = (event: SelectChangeEvent<string>) => {
    setPage(1)
    return setParams(QUERY_PARAMS.ENTITY, event.target.value as string)
  }

  const setParams = (key: QUERY_PARAMS, value: string) => {
    switch (key) {
      case QUERY_PARAMS.USER:
        searchParams.set(key, value)
        break
      case QUERY_PARAMS.ENTITY:
        searchParams.set(key, value)
        break
      case QUERY_PARAMS.FROM:
        searchParams.set(QUERY_PARAMS.FROM, value)
        break
      case QUERY_PARAMS.TO:
        searchParams.set(QUERY_PARAMS.TO, value)
        break

      default:
        searchParams.delete(QUERY_PARAMS.USER)
        searchParams.delete(QUERY_PARAMS.ENTITY)
        break
    }
    setPage(1)
    setSearchParams(searchParams)
  }

  return (
    <CardBox>
      <CardBoxTopBar>
        <Typography fontSize="18px">Filters</Typography>
      </CardBoxTopBar>

      <Box display={'flex'} flexDirection={'column'} gap={3} p={3}>
        <SearchWithKeypress searchPlaceholder="Search Feed" hasMaxWidth={false} />

        <DateRanges setParams={setParams} getFilterValues={getFilterValues} smallTextField={false} mediumViewport />

        <UserFilter label="Select User" setParams={setParams} getFilterValues={getFilterValues} />

        <Box flex={0.75}>
          <FormControl variant="outlined" fullWidth>
            <StyledInputLabel id="entity-label">Select Entity</StyledInputLabel>

            <Select
              label="Select Entity"
              labelId="entity-label"
              id="entity-select"
              defaultValue={QUERY_PARAMS.ALL}
              MenuProps={{
                anchorOrigin,
                transformOrigin,
                PaperProps: {
                  style: {
                    maxHeight: 190,
                    overflowY: 'auto'
                  }
                }
              }}
              onChange={onChangeEntity}
              value={getFilterValues(QUERY_PARAMS.ENTITY) ?? undefined}
              sx={{
                minWidth: 120
              }}
            >
              <MenuItem value={QUERY_PARAMS.ALL}>{'All'}</MenuItem>

              {ACTIVITY_TYPES.map(({ value, label }) => (
                <MenuItem value={value} key={value}>
                  {label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
    </CardBox>
  )
}

export default ActivityFilters
